import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const PasswordPanel = () => {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    if (f.next.length < 10) return toast.error("Use at least 10 characters for your new password.");
    if (f.next !== f.confirm) return toast.error("The new passwords don't match.");
    setBusy(true);
    try {
      await api.post("/admin/password", { current_password: f.current, new_password: f.next });
      setF({ current: "", next: "", confirm: "" });
      toast.success("Password changed. Use your new password next time you log in.");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const field = (k, label, testId, auto) => (
    <label className="block space-y-1.5 text-xs font-mono uppercase text-muted-foreground">{label}
      <Input type="password" value={f[k]} onChange={set(k)} autoComplete={auto} data-testid={testId} className="bg-white normal-case font-sans" />
    </label>
  );
  return (
    <form onSubmit={save} className="rounded-2xl border border-border bg-card p-6 lg:p-8 space-y-4" data-testid="password-panel">
      <h3 className="text-xl flex items-center gap-2"><KeyRound className="h-5 w-5 text-pinkb" />Change my password</h3>
      <p className="text-sm text-muted-foreground">At least 10 characters. A short phrase you'll remember works well, e.g. "roots-sunday-brunch".</p>
      {field("current", "Current password", "password-current-input", "current-password")}
      {field("next", "New password", "password-new-input", "new-password")}
      {field("confirm", "New password again", "password-confirm-input", "new-password")}
      <Button type="submit" disabled={busy || !f.current || !f.next} data-testid="password-save-btn" className="rounded-full bg-navy hover:bg-navy/90 text-white">
        {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Change password
      </Button>
    </form>
  );
};
